// 移动端分类列表断点
var MOBILE_BREAKPOINT = 769;
// bundler save 价格已更新标记类，避免 bundle_widget_created 重复触发时反复修改
var BUNDLER_SAVE_UPDATED_CLASS = "bundler-save-updated";

// 读取 bundler 价格元素的 data-currentprice 与 data-currency-* 展示值
function getBundlerPriceData($priceEl) {
  var $target = $priceEl;

  // 属性可能在子元素 .money 上
  if (!$target.attr("data-currentprice")) {
    var $money = $priceEl.find(".money").first();
    if ($money.length && $money.attr("data-currentprice")) {
      $target = $money;
    }
  }

  var el = $target[0];
  if (!el) return null;

  var currentPrice = Number($target.attr("data-currentprice"));
  if (!currentPrice) return null;

  var currencyValue = "";
  var attrs = el.attributes;

  for (var i = 0; i < attrs.length; i++) {
    if (attrs[i].name.indexOf("data-currency-") === 0) {
      currencyValue = attrs[i].value;
      break;
    }
  }

  return {
    currentPrice: currentPrice,
    currencyValue: currencyValue,
  };
}

// 从 bundler 格式化价格中提取货币符号（如 $305.95 → $）
function extractCurrencySymbol(formattedPrice) {
  var match = String(formattedPrice).match(/^[^\d\s\-]+/);
  return match ? match[0] : "$";
}

// 将分差（分）格式化为 save 文案，保留货币符号
function formatSavePrice(saveCents, symbol) {
  var amount = saveCents / 100;
  var fixed = amount.toFixed(2);
  var formatted = fixed.endsWith(".00") ? fixed.slice(0, -3) : fixed;
  return "save " + symbol + formatted;
}

// 遍历含 bundler 价格的商品卡，用旧价减新价更新 .ann-pro-item-save
function updateBundlerSavePrices() {
  $(".ann-product-item.bundler-price-item").each(function () {
    var $item = $(this);

    // 已更新过的项跳过，避免 bundle_widget_created 多次触发重复修改
    if ($item.hasClass(BUNDLER_SAVE_UPDATED_CLASS)) return;

    var $oldPrice = $item.find(".bndlr-total-price .bndlr-old-price").first();
    var $newPrice = $item.find(".bndlr-total-price .bndlr-new-price").first();

    

    // 旧价或新价不存在时直接跳过
    if (!$oldPrice.length || !$newPrice.length) return;

    var $saveEl = $item.find(".ann-pro-item-save");
    if (!$saveEl.length) return;

    var oldData = getBundlerPriceData($oldPrice);
    var newData = getBundlerPriceData($newPrice);

    // console.log(oldData);
    // console.log(newData);
    // console.log("====================");

    if (!oldData || !newData) return;

    var saveCents = oldData.currentPrice - newData.currentPrice;
    if (saveCents <= 0) return;

    var symbol = extractCurrencySymbol(oldData.currencyValue || newData.currencyValue);
    $saveEl.text(formatSavePrice(saveCents, symbol));
    $item.addClass(BUNDLER_SAVE_UPDATED_CLASS);
  });
}

// bundler 插件每次创建 widget 时更新 save 价格（同一商品只更新一次）
document.addEventListener("bundler:bundle_widget_created", updateBundlerSavePrices);

document.addEventListener("DOMContentLoaded", () => {
  var $productContent = $(".ann-product-content");

  // 将平级的 .ann-list-item 包裹进横向滚动容器（解决 block 嵌套限制）
  function ensureListScrollWrapper() {
    var $existing = $productContent.children(".ann-list-scroll");
    if ($existing.length) return $existing;

    var $listItems = $productContent.children(".ann-list-item");
    if (!$listItems.length) return null;

    var $wrapper = $('<div class="ann-list-scroll"></div>');
    $listItems.first().before($wrapper);
    $listItems.appendTo($wrapper);
    return $wrapper;
  }

  // M 端分类项滚动：首项靠左、末项靠右、中间项居中
  function scrollToListItem($item, behavior) {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    var $wrapper = $item.closest(".ann-list-scroll");
    if (!$wrapper.length) return;

    var $items = $wrapper.find(".ann-list-item");
    var index = $items.index($item);
    var lastIndex = $items.length - 1;
    var wrapperEl = $wrapper[0];
    var itemEl = $item[0];
    var scrollLeft = 0;

    if (index === 0) {
      scrollLeft = 0;
    } else if (index === lastIndex) {
      scrollLeft = wrapperEl.scrollWidth - wrapperEl.clientWidth;
    } else {
      scrollLeft = itemEl.offsetLeft - (wrapperEl.clientWidth - itemEl.offsetWidth) / 2;
    }

    wrapperEl.scrollTo({ left: scrollLeft, behavior: behavior || "smooth" });
  }

  // 初始化 M 端分类滚动位置（按默认 active 项）
  function initMobileListScroll() {
    ensureListScrollWrapper();
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    var $activeItem = $(".ann-list-scroll .ann-list-item.active").first();
    if (!$activeItem.length) {
      $activeItem = $(".ann-list-scroll .ann-list-item").first();
    }
    if ($activeItem.length) {
      scrollToListItem($activeItem, "auto");
    }
  }

  ensureListScrollWrapper();
  initMobileListScroll();

  // 图片等资源加载后重新校准滚动位置
  $(window).on("load", initMobileListScroll);

  // 窗口尺寸变化时重新初始化 M 端滚动
  var resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initMobileListScroll, 150);
  });

  // 分类 tab 切换：同步 active 状态并触发 M 端滚动
  var $RadioItem = $(".ann-radio-item");

  $RadioItem.click(function () {
    var $this = $(this);
    var $listItem = $this.parents(".ann-list-item");
    var index = $listItem.data("index");
    $RadioItem.parents(".ann-list-item").removeClass("active");
    $listItem.addClass("active");
    $(".ann-product-layout").removeClass("active");
    $(".ann-product-layout[data-index='" + index + "']").addClass("active");
    scrollToListItem($listItem, "smooth");
  });

  // Notify Me 按钮：打开 Klaviyo 表单
  var $NotifyBtn = $(".radio-btn.notify-btn, .ann-pro-item-btn.notify-btn");

  $NotifyBtn.click(function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'SzDT9N']);
  });

  // Load More：展示剩余商品并隐藏按钮
  var $LoadMore = $(".load-more");

  $LoadMore.click(function () {
    var $this = $(this);
    $this.siblings(".ann-product-group").find(".ann-product-item").addClass("active");
    $this.hide();
  });

  // bundler 若已先于事件监听渲染完成，尝试更新 save 价格
  updateBundlerSavePrices();
});
